<template>
  <div class="eventList">
    <h3 class="center title">“中国设计年度十大事件”候选事件</h3>
    <div class="container">
      <div v-if="loading" class="note">
        <Icon class="turn" size="50" type="ios-loading" />
        <p>加载中...</p>
      </div>
      <template v-else>
        <template v-if="total>0">
          <Row :gutter="20">
            <Col v-for="l in list" :key="l.id" :lg="6" :md="12" :sm="24" :xs="24">
              <div class="info">
                <p class="ellipsis workName">
                  <router-link :to="`/top_events/detail/${l.id}`">{{l.eventName}}</router-link>
                </p>
                <p class="ellipsis">申报单位 {{l.applicant}}</p>
                <p class="ellipsis">推荐理由 {{l.reason}}</p>
                <!-- <p>
                  <Tooltip :content="l.main" theme="light" max-width="100%" placement="bottom-start">
                    <span class="colorText">主要事迹</span>
                  </Tooltip>
                </p> -->
              </div>
            </Col>
          </Row>
          <div class="pageWrap">
            <Page :total="total" :current="page+1" @on-change="handlePageChange" :page-size="size" show-elevator show-total />
          </div>
        </template>
        <div v-else class="center">
          暂无候选事件
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import competitionService from "@/api/competition";
export default {
  data() {
    return {
      loading: false,
      total: 0,
      list: [],
      page: 0,
      size: 24
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取事件列表
    getList() {
      this.loading = true;
      let condition = {"checkStatus.eq": "SUCCESS"}
      competitionService.getTopEvent(condition).then(res => {
        this.loading = false;
        if (res.errorNo == 0) {
          this.list = res.data;
          this.total = res.data.length;
        } else {
          this.$Message.error(res.errorMessage);
        }
      })
      .catch(() => {
        // this.$Message.error(err.message)
        this.loading = false;
        this.$Message.error("连接服务器失败，请稍后再试");
      });

    },
    // 翻页
    handlePageChange(page) {
      this.page = page - 1;
      this.loading = true;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.eventList {
  .title {
    padding: 15px 0 30px;
  }

  .note {
    padding: 10px 0;
    text-align: center;

    .turn {
      animation: turn 1s linear infinite;
      margin-bottom: 10px;
    }
    @keyframes turn {
      0% {
        -webkit-transform: rotate(0deg);
      }
      25% {
        -webkit-transform: rotate(90deg);
      }
      50% {
        -webkit-transform: rotate(180deg);
      }
      75% {
        -webkit-transform: rotate(270deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
  }
  .info {
    padding: 15px;
    box-shadow: 0 0 10px 2px rgba($color: #000000, $alpha: 0.2);
    border-radius: 5px;
    margin-bottom: 20px;
  }
  .pageWrap {
    text-align: right;
    padding: 20px 0 50px;
  }
}
</style>
